<template>
  <v-text-field
    v-bind="computedProps"
    solo
    flat
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    @input="onInput"
    @blur="onBlur"
    @focus="onFocus"
    @keydown.enter="onKeydownEnter"
    @keydown.tab="onKeydownTab"
    @keydown.esc="onKeydownEsc"
  >
    <template v-slot:append>
      <slot name="append"/>
    </template>
  </v-text-field>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextField } from 'vuetify/lib'

/**
 * @file DDv2用汎用テキスト
 * @namespace components
 */

/**
 * @vue-prop {controls.InputTypes} valueType - 入力タイプ
 * @vue-prop {Boolean} [required=false] - 必須指定
 * @vue-prop {Number} [length=999] - 入力可能桁数
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
  * @vue-prop {Function} [appendFormatter=undefined] - 追加フォーマッタ―
 * @vue-prop {Function} [appendUnFormatter=undefined] - 追加フォーマット解除処理
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @see controls.InputTypes
 * @example
  <dd-text-box
    label="数字"
    v-model="value"
    :length="25"
    :required="true"
    :valueType="controls.InputTypes.Number"/>
 */
export default {
  name: 'DdSpreadSheetTextBox',
  extends: VTextField,
  mixins: [inputMixin],
  props: {
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 必須表示
     */
    showRequire: {
      type: Boolean,
      default: true
    },
    /**
     * 入力可能桁数
     */
    length: Number,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 追加フォーマッタ
     */
    appendFormatter: Function,
    appendUnFormatter: Function
  },
  data: () => ({
    phtext: '',
    invalidMessage: '',
    innerValue: ''
  }),
  created () {
    this.innerValue = this.value
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.phtext = this.length && !this.readonly ? dtl.placeholder.replace('@@length@@', this.length) : ' '
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  watch: {
    value: function (n, o) {
      // console.log('watch value', n, o)
      this.innerValue = n
      this[controls.VALIDATE_METHOD]()
    },
    length: function (n, o) {
      // console.log('watch length', n, o)
      const dtl = controls.getInputTypeDetail(this.valueType)
      if (!dtl) { return }
      this.phtext = this.length && !this.readonly ? dtl.placeholder.replace('@@length@@', this.length) : ' '
    },
    valueType: function (n, o) {
      // console.log('watch valueType', n, o)
      const dtl = controls.getInputTypeDetail(this.valueType)
      if (!dtl) { return }
      this.phtext = this.length && !this.readonly ? dtl.placeholder.replace('@@length@@', this.length) : ' '
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // ackgroundColor: this.required ? controls.Colors.Required : '',
        class: this.$props.class + (this.required ? ' required-item' : ''),
        type: this.inputType,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onInput: function (e) {
      // console.log('onInput', e)
      this.innerValue = e
    },
    onBlur: function (e) {
      // console.log('onBlur', e, this)
      this.$emit('input', this.innerValue)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      if (typeof this.appendUnFormatter === 'function' && this.appendUnFormatter) {
        this.innerValue = this.appendUnFormatter(this.innerValue)
      }
      const elem = this.$el.querySelector('input')
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        this.$emit('focus', e)
      })
    },
    onKeydownEnter: function (e) {
      // console.log('onKeydownEnter')
      this.$emit('enter', e)
    },
    onKeydownTab: function (e) {
      // console.log('onKeydownTab')
      this.$emit('tab', e)
    },
    onKeydownEsc: function (e) {
      // console.log('onKeydownEsc')
      this.$emit('esc', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        console.log(target, f.name)
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          // this.$set(this, 'invalidMessage', ret)
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
      if (typeof this.appendFormatter === 'function' && this.appendFormatter) {
        this.innerValue = this.appendFormatter(this.innerValue)
        this.$emit('input', this.innerValue)
        console.log(controls.FORMAT_METHOD, this.innerValue)
      }
    }
  }
}
</script>
<style scoped>
</style>
